export { default } from './TextWithIcon';
